import type { FC, ReactNode } from 'react'

import { CalendarCheck, Clock, Globe } from 'lucide-react'
import { Asterisk } from '@/components/generals/asterisk'
import { SectionLabel } from '@/components/generals/section-label'
import { ContactForm } from '@/components/landing/contact-form'
import { siteConfig } from '@/constants/site'

const highlights = [
    { icon: CalendarCheck, label: siteConfig.availability },
    { icon: Clock, label: "Replies within two business days" },
    { icon: Globe, label: "Based in Lisbon, working with clients worldwide" }
]

export const Contact: FC = (): ReactNode => {
    return (
        <section id='contact' data-surface='brand' className='relative isolate overflow-hidden bg-brand py-20 text-brand-foreground md:py-32'>
            <Asterisk className='spin-slow pointer-events-none absolute -right-[14vw] -top-[12vw] -z-10 size-[48vw] text-white/[0.06]' />

            <div className='page-container grid gap-14 lg:grid-cols-12 lg:gap-10'>
                <div className='lg:col-span-5'>
                    <SectionLabel className='text-brand-foreground/75' markClassName='text-brand-foreground'>
                        Contact
                    </SectionLabel>

                    <h2 className='mt-5 text-balance font-heading text-[clamp(3rem,7vw,6.5rem)] font-semibold leading-[0.9] tracking-[-0.045em]'>
                        Got a project? Let's make it <em className='font-serif font-normal italic tracking-[-0.02em]'>loud</em>.
                    </h2>

                    <p className='mt-6 max-w-md text-lg leading-relaxed text-brand-foreground/80'>
                        Tell me a little about your idea. I'll reply with next steps, a rough timeline and honest advice, even if I'm not the right fit.
                    </p>

                    <ul className='mt-10 space-y-4 border-t border-brand-foreground/20 pt-8'>
                        {highlights.map(item => (
                            <li key={item.label} className='flex items-start gap-3 text-brand-foreground/90'>
                                <item.icon className='mt-0.5 size-5 shrink-0' />
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='lg:col-span-7'>
                    <ContactForm />
                </div>
            </div>
        </section>
    )
}
